import {
  SvgCallToAction,
  SvgImage1,
  SvgNotes,
  SvgScissors,
  SvgTune,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import {
  VIDEO_ENTER_TRIM_MODE,
  VIDEO_TOGGLE_TRANSCRIPT,
} from 'constants/hotkeys';
import { ANON_CREATOR_SIGNUP_MODAL } from 'constants/modalTypes';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import CollapsibleSideButton from '../collapsible-side-button';
import VideoButtons from '../video-buttons';
import { EXPERIMENT_RENAME_CTA } from '../../../../../shared/constants/featureFlag';

const AnonEditVideoButtons = ({
  // collapsed = only icons are showing, text is hidden
  // collapsible = can change state into collapsed state (false = force uncollapsed)
  // hidden = this component renders nothing
  isCollapsible = false,
  isHidden,
  startCollapsed = false,
}) => {
  const dispatch = useDispatch();
  const openAnonCreatorAuthModal = () => {
    dispatch(openModal(ANON_CREATOR_SIGNUP_MODAL));
  };

  const renameCTAFlag = useFeatureFlagValue(EXPERIMENT_RENAME_CTA);

  return (
    <VideoButtons
      startCollapsed={startCollapsed}
      isCollapsible={isCollapsible}
      isHidden={isHidden}
    >
      {({ isCollapsed }) => (
        <div className="p:xsmall">
          <CollapsibleSideButton
            onClick={openAnonCreatorAuthModal}
            icon={<SvgNotes />}
            isCollapsed={isCollapsed}
          >
            Review transcript ({VIDEO_TOGGLE_TRANSCRIPT[0]})
          </CollapsibleSideButton>
          <CollapsibleSideButton
            onClick={openAnonCreatorAuthModal}
            icon={<SvgTune style={{ transform: 'rotate(90deg)' }} />}
            isCollapsed={isCollapsed}
          >
            Video preferences
          </CollapsibleSideButton>
          <CollapsibleSideButton
            icon={<SvgScissors />}
            isCollapsed={isCollapsed}
            onClick={openAnonCreatorAuthModal}
          >
            <div dir="ltr">Trim video ({VIDEO_ENTER_TRIM_MODE[0]})</div>
          </CollapsibleSideButton>
          <CollapsibleSideButton
            icon={<SvgCallToAction />}
            isCollapsed={isCollapsed}
            onClick={openAnonCreatorAuthModal}
          >
            {renameCTAFlag ? 'Add a link' : 'Call-to-action'}
          </CollapsibleSideButton>
          <CollapsibleSideButton
            icon={<SvgImage1 />}
            isCollapsed={isCollapsed}
            onClick={openAnonCreatorAuthModal}
          >
            Change thumbnail
          </CollapsibleSideButton>
        </div>
      )}
    </VideoButtons>
  );
};

export default AnonEditVideoButtons;
